<template>
	<v-dialog v-model="ui.dialog" persistent max-width="650">
		<v-card class="pa-4">
			<v-card-title>
				Nuevo metodo de envío
			</v-card-title>
			<v-card-text class="pb-0">
				<v-form
					ref="form"
					v-model="ui.valid"
					lazy-validation
					@submit.prevent="store()"
				>
					<v-row>
						<v-col cols="12" md="6" class="pb-0">
							<v-text-field
								clearable
								label="Nombre"
								:error-messages="errorMessages.name"
								v-model="layout.name"
								outlined
								dense
								:rules="[v.required]"
							></v-text-field>
						</v-col>

						<v-col cols="12" md="6" class="pb-0">
							<v-text-field
								clearable
								label="Id NetSuite"
								:error-messages="errorMessages.idnetsuite"
								v-model="layout.idnetsuite"
								outlined
								dense
								type="number"
								:rules="[v.required, v.integer]"
							></v-text-field>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="ui.dialog = false" :disabled="ui.storing">
					Cancelar
				</v-btn>
				<v-btn color="primary" @click="store()" :loading="ui.storing">
					Enviar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
	
import { EventBus } from "@/main";
import { V } from "@/main";
import axios from "axios";

export default {
	data() {
		return {
			v: V,

			session: null,

			layout: {
				name: null,
				idnetsuite: null,
			},

			ui: {
				valid: true,
				dialog: false,
				storing: false,
			},

			errorMessages: {
				name: [],
			},
		};
	},

	mounted() {
		this.session = JSON.parse(localStorage.getItem("session"));

		EventBus.$on("ShippingMethodCreate", () => {
			this.ui.dialog = true;
		});

		EventBus.$on("InputError", (errors) => {
			this.errorMessages = errors;
		});
	},

	methods: {
		async store() {
			if (this.$refs.form.validate()) {
				this.messagesErrorsClear();

				this.ui.storing = true;

				try {
					let response = await axios.post(
						`${process.env.VUE_APP_API_SERVER}/shippingmethod`,
						this.layout
					);

					this.ui.dialog = false;

					this.$refs.form.reset();

					this.$store.dispatch(
						"setShippingMethod",
						response.data.data
					);
				} catch (error) {
					EventBus.$emit("Error", { error: error, alertShow: false });
				} finally {
					this.ui.storing = false;
				}
			}
		},

		messagesErrorsClear() {
			for (var i in this.errorMessages) {
				this.errorMessages[i] = [];
			}
		},
	},
};
</script>
